// extracted by mini-css-extract-plugin
module.exports = {"dotsLoading":"index_dotsLoading__dfCWO","dots":"index_dots__UCNbP","dotItem":"index_dotItem__hja7h","dot-color-change":"index_dot-color-change__hlGPI"};